module.exports = {
  init: function($) {
    "use strict";
    var post_id = localStorage.getItem("popup-agilis");
    if ($("#popup-container").length && $(window).width() > 960) {
      var post_id_closed = $("#popup-container").data("postid");
      console.log(post_id);
      console.log(post_id_closed);
      if (!post_id || post_id.toString() !== post_id_closed.toString()) {
        $("#popup-container").fadeIn();
        $("body").addClass("has-overlay");
      }
    }
    $(".close-popup").on("click", function(e) {
      e.preventDefault();
      $("#popup-container").fadeOut();
      $("body").removeClass("has-overlay");
    });

    $(".nothanks").on("click", function(e) {
      e.preventDefault();
      var $this = $(this);
      localStorage.setItem("popup-agilis", $this.data("postid"));
      $("#popup-container").fadeOut();
      $("body").removeClass("has-overlay");
    });
  }
};
